"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const lodash_1 = require("lodash");
const prop_types_1 = __importDefault(require("prop-types"));
const FeatureToggle = (props) => {
    const { data, children, name, field } = props;
    const component = react_1.memo(() => {
        return react_1.useMemo(() => {
            if (name && children && data && lodash_1.isArray(data) && data.findIndex((item) => item[field] === name) > -1) {
                return children;
            }
            return null;
        }, [data, children, name, field]);
    });
    component.displayName = 'c';
    return component;
};
FeatureToggle.PropTypes = {
    name: prop_types_1.default.string,
};
FeatureToggle.displayName = 'FeatureToggle';
exports.default = FeatureToggle;
